import * as React from 'react';

import { cn } from '@/lib/helpers/utils';

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<'textarea'>
>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        'flex min-h-[60px] text-white w-full rounded-md border-2 border-input bg-transparent px-3 py-2 text-base shadow-sm placeholder:text-muted-foreground focus:border-[#1efcf9d9] transition duration-300 ease-in-out focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
        className
      )}
      ref={ref}
      {...props}
    />
  );
});
Textarea.displayName = 'Textarea';

export { Textarea };
